import { bus_xe, BusXeItemResponse } from "../../../models/response/bus/bus_xe";
import {
	eBusXeActionTypeIds, IBusXeChangeSelectedIds, IBusXeCloseConfirm, IBusXeCloseDetail,
	IBusXeDeleteErr, IBusXeDeleteStart, IBusXeDeleteSuccess,
	IBusXeLoadErr, IBusXeLoadStart, IBusXeLoadSuccess,
	IBusXeSaveErr, IBusXeSaveStart, IBusXeSaveSuccess,
	IBusXeShowConfirm, IBusXeShowDetail
} from "../../action-types/bus/IBusXeActionTypes";

export const busXeActions = {
	loadBusXeStart: (dm_coso_id: number): IBusXeLoadStart => {
		return {
			type: eBusXeActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadBusXeSuccess: (data: BusXeItemResponse[]): IBusXeLoadSuccess => {
		return {
			type: eBusXeActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusXeError: (message: string): IBusXeLoadErr => {
		return {
			type: eBusXeActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	showBusXeDetail: (data?: BusXeItemResponse): IBusXeShowDetail => {
		return {
			type: eBusXeActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeBusXeDetail: (): IBusXeCloseDetail => {
		return {
			type: eBusXeActionTypeIds.CLOSE_DETAIL
		}
	},
	changeBusXeSelectedIds: (ids: number[]): IBusXeChangeSelectedIds => {
		return {
			type: eBusXeActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showBusXeConfirm: (data?: BusXeItemResponse): IBusXeShowConfirm => {
		return {
			type: eBusXeActionTypeIds.SHOW_CONFIRM,
			payload: data
		}
	},
	closeBusXeConfirm: (): IBusXeCloseConfirm => {
		return {
			type: eBusXeActionTypeIds.CLOSE_CONFIRM
		}
	},
	deleteBusXeStart: (id: number): IBusXeDeleteStart => {
		return {
			type: eBusXeActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteBusXeSuccess: (): IBusXeDeleteSuccess => {
		return {
			type: eBusXeActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteBusXeErr: (message: string): IBusXeDeleteErr => {
		return {
			type: eBusXeActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	saveBusXeStart: (data: bus_xe): IBusXeSaveStart => {
		return {
			type: eBusXeActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveBusXeSuccess: (): IBusXeSaveSuccess => {
		return {
			type: eBusXeActionTypeIds.SAVE_SUCCESS
		}
	},
	saveBusXeError: (message: string): IBusXeSaveErr => {
		return {
			type: eBusXeActionTypeIds.SAVE_ERROR,
			payload: message
		}
	}
}
